import CustomAxios from '../../CustomAxios/CustomAxios';


export const updateNotificationStatusAPI = (data: any) => {
  return CustomAxios.put(`${process.env.REACT_APP_NOTIFICATIONS_URL}/dev/notifications`, data);
};